"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventTimeTimer = void 0;
const react_1 = require("react");
const useInterval_1 = require("./useInterval");
const useEventTimeTimer = ({ currentTime, remainingTime }) => {
    var _a;
    const selectedTime = (0, react_1.useMemo)(() => (currentTime || remainingTime), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentTime === null || currentTime === void 0 ? void 0 : currentTime.value, remainingTime === null || remainingTime === void 0 ? void 0 : remainingTime.value]);
    const lastSavedTimeDataRef = (0, react_1.useRef)();
    const [timerTime, setTimerTime] = (0, react_1.useState)(selectedTime.value);
    const [isStop, setIsStop] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const { current: lastSavedTimeData } = lastSavedTimeDataRef;
        if (lastSavedTimeData === undefined) {
            lastSavedTimeDataRef.current = selectedTime;
            setTimerTime(selectedTime.value);
            return;
        }
        if (lastSavedTimeData.value === selectedTime.value) {
            setIsStop(true);
            setTimerTime(lastSavedTimeData.value);
        }
        else {
            lastSavedTimeDataRef.current = selectedTime;
            setTimerTime(selectedTime.value);
            setIsStop(false);
        }
    }, [selectedTime, (_a = lastSavedTimeDataRef.current) === null || _a === void 0 ? void 0 : _a.value]);
    (0, useInterval_1.useInterval)(() => {
        const [minutesString, secondsString] = timerTime.split(':');
        const minutes = +minutesString;
        const seconds = +secondsString;
        if (selectedTime.code === (currentTime === null || currentTime === void 0 ? void 0 : currentTime.code)) {
            if (seconds === 59) {
                setTimerTime(`${getFormattedMinutes(minutes + 1)}:00`);
            }
            else {
                setTimerTime(`${getFormattedMinutes(minutes)}:${getFormattedMinutes(seconds + 1)}`);
            }
            return;
        }
        if (selectedTime.code === (remainingTime === null || remainingTime === void 0 ? void 0 : remainingTime.code)) {
            if (!(minutes || seconds)) {
                setIsStop(true);
                return;
            }
            if (seconds === 0) {
                setTimerTime(`${getFormattedMinutes(minutes - 1)}:${getFormattedMinutes(59)}`);
            }
            else {
                setTimerTime(`${getFormattedMinutes(minutes)}:${getFormattedMinutes(seconds - 1)}`);
            }
        }
    }, isStop ? null : 1000, true);
    return { timerTime };
};
exports.useEventTimeTimer = useEventTimeTimer;
const getFormattedMinutes = (time) => (time < 10 ? `0${time}` : time);
//# sourceMappingURL=useEventTimeTimer.js.map